import { render, staticRenderFns } from "./Header-top.vue?vue&type=template&id=2f0b132e&scoped=true&"
import script from "./Header-top.vue?vue&type=script&lang=js&"
export * from "./Header-top.vue?vue&type=script&lang=js&"
import style0 from "./Header-top.vue?vue&type=style&index=0&id=2f0b132e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f0b132e",
  null
  
)

export default component.exports